import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import type { Item, ShippingMethodsAPIResponse } from 'typings'
import { useFetch } from './useFetch'

export function getUniqueShippingMethods(
  response: ShippingMethodsAPIResponse
): Item[] {
  const uniqueSlaTypes = new Set(response.map(({ slaType }) => slaType))
  return Array.from(uniqueSlaTypes).map((slaType) => ({
    id: slaType,
    name: slaType,
  }))
}

export function useShippingMethods(options?: Partial<UseQueryOptions<Item[]>>) {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/logistics/pvt/configuration/freights?externalCarriers=true`,
    window.location.origin
  )

  async function fetcher() {
    return fetcherWrapper(url.toString())
      .then((r) => r.json())
      .then((response: ShippingMethodsAPIResponse) =>
        getUniqueShippingMethods(response)
      )
  }

  return useQuery<Item[]>({
    queryKey: ['logistics-shipping-methods'],
    queryFn: fetcher,
    ...options,
    retry: false,
  })
}
